import { Trans } from "@lingui/react";

const Disclaimer = () => {
  return (
    <div className="mt-16 md:mt-24">
      <h4>
        <Trans id="itemPageLayout.disclamerTitle" message="About the information in this ad" />
      </h4>
      <p>
        <Trans
          id="itemPageLayout.disclamer"
          message="The description, price and images in this ad are provided by the seller. Technical specifications and other data are supplied by the seller or by third parties, including the manufacturer and public registers."
        />
      </p>
      <p>
        <Trans
          id="itemPageLayout.disclamerTechnicalData"
          message="Technical data may describe the general specification for this model and model year, and may not match the exact specification of what is being sold. Equipment and condition can differ between individual units. Information may be incomplete, outdated or incorrect."
        />
      </p>
      <p>
        <Trans
          id="itemPageLayout.disclamerIndicativeValues"
          message="Where figures for consumption, range, capacity or performance are shown, these are indicative values based on standardized testing. Actual figures vary with condition, load and use."
        />
      </p>
      <p className="mb-0">
        <Trans
          id="itemPageLayout.disclamerVerify"
          message="We recommend you verify the details that matter to you with the seller before you buy."
        />
      </p>
    </div>
  );
};

export default Disclaimer;
